import type { ReactNode } from 'react';

function isEmptyContent(content: unknown): boolean {
  if (content == null) {
    return true;
  }

  if (content === '') {
    return true;
  }

  if (content === false) {
    return true;
  }

  if (Array.isArray(content) && content.length === 0) {
    return true;
  }

  return false;
}

export interface CellItemProps<T> {
  value: T;

  render?: (value: NonNullable<T>) => ReactNode;

  empty?: ReactNode;

  children?: ReactNode;
}

export function NonEmpty<T = unknown>(props: CellItemProps<T>) {
  const empty = props.empty;

  if (isEmptyContent(props.value)) {
    return empty;
  }

  if (props.render) {
    return props.render(props.value as NonNullable<T>);
  }

  if (props.children) {
    return props.children;
  }

  return props.value as ReactNode;
}
